export default __webpack_public_path__ + "static/media/HIVInfog.8ead0744.png";